class GetVolumeByIdSectorAndTimeUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute(FK_SECTOR,FK_VALVE,TIME){
    const result= await this.repository.showVolumeByIdValveAndIdSectorAndTime(FK_SECTOR,FK_VALVE,TIME)
    if(result && result.length){
      return result[0] //{}
    }
  }
}
export {
  GetVolumeByIdSectorAndTimeUseCase,
};
